import { render, staticRenderFns } from "./StakewiseRewards.vue?vue&type=template&id=076315c4&scoped=true"
import script from "./StakewiseRewards.vue?vue&type=script&lang=js"
export * from "./StakewiseRewards.vue?vue&type=script&lang=js"
import style0 from "./StakewiseRewards.vue?vue&type=style&index=0&id=076315c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "076315c4",
  null
  
)

export default component.exports